import { render, staticRenderFns } from "./settings-payments.vue?vue&type=template&id=d812bfd6"
import script from "./settings-payments.vue?vue&type=script&lang=js"
export * from "./settings-payments.vue?vue&type=script&lang=js"
import style0 from "./settings-payments.vue?vue&type=style&index=0&id=d812bfd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports